import React, { useState } from 'react';
import MarkdownMessage from './MarkdownMessage';

function ThumbUpIcon() {
  return (
    <svg className="nudge-batch__icon" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
        d="M8 11.5 V19.5 H6.2 A1.2 1.2 0 0 1 5 18.3 V12.7 A1.2 1.2 0 0 1 6.2 11.5 H8 Z"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
        d="M8 18.8 H17.2 A1.6 1.6 0 0 0 18.8 17.4 L19.6 13.2 A1.4 1.4 0 0 0 18.2 11.5 H13.2 L14.1 7.4 A1.3 1.3 0 0 0 12.8 5.8 L8 11.5"
      />
    </svg>
  );
}

function ThumbDownIcon() {
  return (
    <svg className="nudge-batch__icon" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
        d="M16 12.5 V4.5 H17.8 A1.2 1.2 0 0 1 19 5.7 V11.3 A1.2 1.2 0 0 1 17.8 12.5 H16 Z"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
        d="M16 5.2 H6.8 A1.6 1.6 0 0 0 5.2 6.6 L4.4 10.8 A1.4 1.4 0 0 0 5.8 12.5 H10.8 L9.9 16.6 A1.3 1.3 0 0 0 11.2 18.2 L16 12.5"
      />
    </svg>
  );
}

const NudgeBatch = ({ items = [], hatch, onVote, disabled = false }) => {
  const [pendingId, setPendingId] = useState(null);
  const [chosen, setChosen] = useState({});

  const handleVote = async (itemId, vote) => {
    if (disabled || !onVote || pendingId === itemId) return;
    const previous = Object.prototype.hasOwnProperty.call(chosen, itemId)
      ? chosen[itemId]
      : undefined;
    setChosen((current) => ({ ...current, [itemId]: vote }));
    setPendingId(itemId);
    try {
      await onVote(itemId, vote);
    } catch {
      setChosen((current) => {
        const next = { ...current };
        if (previous === undefined) delete next[itemId];
        else next[itemId] = previous;
        return next;
      });
    } finally {
      setPendingId(null);
    }
  };

  return (
    <div className="nudge-batch" role="list" aria-label="Nudge directions">
      {items.map((item, index) => {
        const vote = Object.prototype.hasOwnProperty.call(chosen, item.id)
          ? chosen[item.id]
          : (item.vote || null);
        return (
          <article
            key={item.id}
            className={[
              'nudge-batch__item',
              vote === 'up' ? 'nudge-batch__item--kept' : '',
              vote === 'down' ? 'nudge-batch__item--skipped' : '',
            ].filter(Boolean).join(' ')}
            role="listitem"
          >
            <p className="nudge-batch__eyebrow">Direction {index + 1}</p>
            <div className="nudge-batch__text chat-message__content--markdown">
              <MarkdownMessage content={item.text} />
            </div>
            <div className="nudge-batch__votes">
              <button
                type="button"
                className={`nudge-batch__vote${vote === 'up' ? ' nudge-batch__vote--active' : ''}`}
                aria-pressed={vote === 'up'}
                aria-label="Keep this direction"
                disabled={disabled}
                onClick={() => handleVote(item.id, vote === 'up' ? null : 'up')}
              >
                <ThumbUpIcon />
                <span>Keep</span>
              </button>
              <button
                type="button"
                className={`nudge-batch__vote nudge-batch__vote--skip${vote === 'down' ? ' nudge-batch__vote--active' : ''}`}
                aria-pressed={vote === 'down'}
                aria-label="Skip this direction"
                disabled={disabled}
                onClick={() => handleVote(item.id, vote === 'down' ? null : 'down')}
              >
                <ThumbDownIcon />
                <span>Skip</span>
              </button>
            </div>
          </article>
        );
      })}
      {hatch ? (
        <p className="nudge-batch__hatch">{hatch}</p>
      ) : null}
    </div>
  );
};

export default NudgeBatch;
